import {
  SA_GET_OFFERS_LISTING,
  SA_GET_OFFERS_LISTING_SUCCESS,
  SA_GET_OFFERS_LISTING_FAILED,
  SA_OFFER_EDIT,
  SA_OFFER_EDIT_SUCCESS,
  SA_OFFER_EDIT_FAIL,
  SA_OFFER_UPDATE,
  SA_OFFER_UPDATE_SUCCESS,
  SA_OFFER_UPDATE_FAIL,
} from "./actionTypes"

const initialState = {
  error: null,
  loading: false,
  msg: null,
  offer: [],
  offerEdit: null,
  offerUpdate: null,
}

const saOffer = (state = initialState, action) => {
  switch (action.type) {
    case SA_GET_OFFERS_LISTING:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        offer: action.payload,
      }
      break
    case SA_GET_OFFERS_LISTING_SUCCESS:
      state = { ...state, error: null, loading: false, offer: action.payload }
      break
    case SA_GET_OFFERS_LISTING_FAILED:
      state = {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case SA_OFFER_EDIT:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        offerEdit: action.payload,
      }
      break
    case SA_OFFER_EDIT_SUCCESS:
      if (state === null || state.offer.length === 0) {
        state = {
          ...state,
          loading: false,
          error: null,
          msg: null,
          offer: [...state.offer, action.payload],
        }
      } else {
        state = {
          ...state,
          loading: false,
          error: null,
          msg: null,
          offer: state.offer.map(i =>
            i.offer_id === action.payload.offer_id ? action.payload : i
          ),
        }
      }
      break
    case SA_OFFER_EDIT_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case SA_OFFER_UPDATE:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        offerUpdate: action.payload,
      }
      break
    case SA_OFFER_UPDATE_SUCCESS:
      state = { ...state, error: null, msg: null, loading: false }
      break
    case SA_OFFER_UPDATE_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
  }
  return state
}

export default saOffer
